<template>
  <div class="sidebar">
    <div class="logo">
      <img src="@/assets/logo.jpg" alt="巡山客" class="logo-icon" />
      <span class="logo-text">巡山客</span>
    </div>
    <div class="menu-container">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        router
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-house"></i>
          <span>首页</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>核心业务</span>
          </template>
          <el-menu-item index="/routes">
            <i class="el-icon-location"></i>
            <span>线路管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/leaders">
            <i class="el-icon-user"></i>
            <span>领队管理</span>
          </el-menu-item>
          <el-menu-item index="/orders">
            <i class="el-icon-document"></i>
            <span>订单管理</span>
          </el-menu-item>
          <el-menu-item index="/reports">
            <i class="el-icon-s-data"></i>
            <span>运营报表</span>
          </el-menu-item> -->
        </el-submenu>
        <el-menu-item index="/users">
          <i class="el-icon-user-solid"></i>
          <span>用户管理</span>
        </el-menu-item>
        <!-- <el-menu-item index="/settings">
          <i class="el-icon-setting"></i>
          <span>系统设置</span>
        </el-menu-item> -->
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar'
}
</script>

<style scoped>
.sidebar {
  width: 200px;
  background-color: #ffffff;
  min-height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
}

.logo {
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.logo-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  margin-right: 12px;
  object-fit: cover;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.menu-container {
  flex: 1;
  padding: 16px 0;
}
</style>
